export const PRIMARY_COLOR = "#002D96";
export const WHITE_COLOR = "#FFF";
export const LIGHT_GRAY = "#909090";
export const LIGHT_TEXT_GRAY = "#666666";
export const PRIMARY_HOVER_COLOR = "#4160a7";
export const YELLOW_COLOR = "#EEBB4D";
export const PRIMARY_BG_COLOR = "#eff4ff"

export const LIGHT_GARY_COLOR_TRASN = "#22222266";
